import React from "react";
import Slider from "react-slick";

function Responsive() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section id="certificate" className="certificate-mf sect-pt4 route">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="title-box text-center">
              <h3 className="title-a">Certificate</h3>
              <p className="subtitle-a">Here are my achievements.</p>
              <div className="line-mf"></div>
            </div>
          </div>
        </div>
        <Slider {...settings}>
          <div>
            <img
              style={{ width: "100%", padding: "0 10px" }}
              src='https://api2.sololearn.com/v2/certificates/CT-JIJE3YFH/image/jpg'
              alt="solohtml"
            />
          </div>
          <div>
            <img
              style={{ width: "100%", padding: "0 10px" }}
              src='https://api2.sololearn.com/v2/certificates/CT-NP36WYKG/image/jpg'
              alt="solojs"
            />
          </div>
          <div>
            <img
              style={{ width: "100%", padding: "0 10px" }}
              src='https://api2.sololearn.com/v2/certificates/CC-BURVTUNC/image/jpg'
              alt="solojs"
            />
          </div>
          <div>
            <img
              style={{ width: "100%", padding: "0 10px" }}
              src='https://s6.imgcdn.dev/xa13C.webp'
              alt="freecodecamp"
            />
          </div>
          <div>
            <img
              style={{ width: "100%", padding: "0 10px" }}
              src='https://s6.imgcdn.dev/xaSJd.webp'
              alt="yrs"
            />
          </div>
          <div>
            <img
              style={{ width: "100%", padding: "0 10px" }}
              src='https://s6.imgcdn.dev/xaGRM.webp'
              alt="udemywp"
            />
          </div>
          <div>
            <img
              style={{ width: "100%", padding: "0 10px" }}
              src='https://s6.imgcdn.dev/xaz4H.webp'
              alt="ethproof"
            />
          </div>
          <div>
            <img
              style={{ width: "100%", padding: "0 10px" }}
              src='https://s6.imgcdn.dev/xaa0S.webp'
              alt="awesomeday"
            />
          </div>
        </Slider>
      </div>
    </section>
  );
}

export default Responsive;
